import notice from '@/components/common/Notice'
import { loginGG } from '../services'
import type { LoginGGParams } from '../types/indentityLoginType'

export const useGoogleLogin = () => {
  const handleGoogleLogin = (payload: LoginGGParams) => {
    try {
      const loginUrl = loginGG(payload)

      // Không có URL
      if (!loginUrl) {
        notice({
          msg: 'Không tạo được URL đăng nhập Google.',
          isSuccess: false,
        })
        return
      }

      // URL không hợp lệ
      if (typeof loginUrl !== 'string') {
        notice({
          msg: 'URL đăng nhập không hợp lệ.',
          isSuccess: false,
        })
        return
      }

      // Sai protocol
      if (!loginUrl.startsWith('http')) {
        notice({
          msg: 'URL đăng nhập Google không đúng định dạng.',
          isSuccess: false,
        })
        return
      }

      // Redirect
      window.location.href = loginUrl
    } catch (error) {
      console.error('Google Login Error:', error)

      notice({
        msg: 'Có lỗi xảy ra khi đăng nhập Google.',
        isSuccess: false,
      })
    }
  }

  return {
    handleGoogleLogin,
  }
}
